export const loadScript = (src: string): Promise<void> => new Promise((resolve, reject) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = src;

  // Then bind the event to the callback function.
  // There are several events for cross browser compatibility.
  script.onload = () => {
    resolve();
  };
  script.onerror = (event, source, lineno, colno, error) => {
    reject(error ?? new Error(`Could not load script: ${source}`));
  };

  document.head.appendChild(script);
});

export const inIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};
